module.exports = __webpack_public_path__ + "static/media/33-13.eeb09e18.mp3";